import Api from '@/api'

export default {
  namespaced: true,

  actions: {
    async shareByEmail({ commit }, email) {
      await new Promise(async (resolve, reject) => {
        Api.post('auth/profile/share-by-email', {
          destination_email: email,
        })
          .then((res) => resolve(res))
          .catch((err) => reject(err))
      })
    },
  },
}
